import {
  Button,
  ButtonState,
} from '@delmonicos/shared-design-system-react/src/components/button/button';
import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { TextInput } from '@delmonicos/shared-design-system-react/src/components/input/text-input';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import * as css from '../../login.module.scss';
import { OtpResendLinkComponent } from '../../otp-resend-link.component';
import {
  EmailOtpForm,
  useEmailOtpFormValidation,
} from './use-otp.form-validation';

interface EmailOtpStepViewProps {
  emailAddress?: string;
  pending: boolean;
  isError: boolean;
  onSubmit: (payload: EmailOtpForm) => void;
  onResendOtp: () => void;
}

export const OtpStepView = ({
  emailAddress = '',
  pending,
  isError,
  onSubmit,
  onResendOtp,
}: EmailOtpStepViewProps): React.JSX.Element => {
  const { t } = useTranslation();

  const formValidation = useEmailOtpFormValidation();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
  } = useForm<EmailOtpForm>({
    mode: 'all',
    defaultValues: {
      emailAddress,
    },
  });

  return (
    <>
      <h1>{t('$.login.otp-step.title')}</h1>
      <p>{t('$.login.otp-step.description')}</p>
      <form onSubmit={handleSubmit(onSubmit)}>
        <TextInput
          {...register('code', {
            ...formValidation.code,
          })}
          onChange={(e) => {
            const cleaned = e.target.value.replace(/\s+/g, '');
            setValue('code', cleaned, {
              shouldValidate: true,
              shouldTouch: true,
            });
          }}
          autoFocus
          errorMessage={errors?.code?.message}
          label={t('verify-otp.code')}
        />
        <div className={css.options}>
          {isError ? (
            <Text color={TextColor.Error}>
              {t('$.login.otp-step.error-otp')}
            </Text>
          ) : (
            <div />
          )}
          <OtpResendLinkComponent onResendOtp={onResendOtp} />
        </div>
        <Button
          type="submit"
          className={css.login}
          disabled={!isValid}
          state={pending ? ButtonState.Loading : ButtonState.Default}>
          <Stack gap={GapEnum.XS} alignItems="center">
            <Icon name="log-in-02" />
            {t('$.login.connect')}
          </Stack>
        </Button>
      </form>
    </>
  );
};
